import { IntegrationType } from '@app/utils/consts';
import { apiInstance } from './api';
import { ApiRoutes } from './consts';


export const getNangoConnectSessionToken = async (integrationType: IntegrationType) => {
  return apiInstance.post(
      `${ApiRoutes.Nango}/connect-token`,
      {
        integrationType,
      }
  );
};
